var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('loginbox'),_vm._v(" "),_c('search'),_vm._v(" "),_c('tablist',{attrs:{"title":'出售大厅',"showbtn":true,"hotshow":true,"detailshow":false},on:{"funBuy":_vm.funBuy}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b69d7d3a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/rehall/rehall.vue
// module id = 476
// module chunks = 13